module.exports = __webpack_public_path__ + "img/cash-voucher.17ee0442.png";